import styled from '@emotion/styled/macro';
import { Card, Variables } from '@enter/core';

interface IDataTableCardProps {
    loading: boolean;
    empty: boolean;
}

export const DataTableCard = styled(Card)<IDataTableCardProps>`
    display: flex;
    flex-direction: column;
    flex-grow: 3;
    padding: 0;
    width: 100%;
    overflow-x: auto;

    .ReactTable {
        width: 100%;
    }

    .rt-th,
    .rt-td {
        white-space: nowrap;
        cursor: pointer;
    }

    .rt-td {
        padding: 0;
        & a,
        & span {
            padding: 16px;
        }
    }

    .rt-tr {
        &:hover {
            background-color: ${Variables.Colors.n5};
        }
    }

    .rt-tbody {
        border-top: ${Variables.Borders.regular};
        /* suppress border during load since row group is still rendered */
        .rt-tr-group {
            ${(props: IDataTableCardProps): string => (props.loading || props.empty ? 'box-shadow: none' : '')};
        }
    }
`;
